import React from "react"
import Popup from "../../../components/Popup/Popup"

import ReportForm from "../../../forms/ReportForm/ReportForm"

const ReportPopup = ({
  data,
  closeAction,
  title = "Inappropriate page report",
  onSubmit,
  setVisiblePopup,
}) => {
  return (
    <Popup
      width={496}
      title={title}
      isCrossIcon
      closeAction={closeAction}
      closeByOutsideClick={true}
    >
      <ReportForm
        data={data}
        closeAction={closeAction}
        onSubmit={onSubmit}
        setVisiblePopup={setVisiblePopup}
      />
    </Popup>
  )
}

export default ReportPopup
